import Link from "next/link";
import router from '@/../config/router.json'
import { createSearchPagePathname } from "@/services/pathname";

type SearchNavProps = {
    sector: string,
    object: string
}

export default function SearchNav({
    sector = '',
    object = ''
}: SearchNavProps) {

    return (
        <div className="d-flex flex-wrap x-gap-0 y-gap-20 justify-start">
            <Link href={'/recherche'} className={"link text-primary" + (sector === 'Common' ? ' all active' : '')}>
                <i className="fi fi-rr-house-chimney" />
                Tout rechercher
            </Link>
            <Link href={createSearchPagePathname('object', 'HolidayStay')} className={"link text-primary" + (object === 'HolidayStay' ? ' all active' : '')}>
                <i className="fi fi-rr-camping" />
                Séjours de vacances
            </Link>
            <Link href={createSearchPagePathname('object', 'Bafad')} className={"link text-primary" + (object === 'Bafad' ? ' all active' : '')}>
                <i className="fi fi-rr-user-graduate" />
                BAFA - BAFD
            </Link>
            <Link href={createSearchPagePathname('object', 'EducationCourse')} className={"link text-primary" + (object === 'EducationCourse' ? ' all active' : '')}>
                <i className="fi fi-rr-users-class" />
                Education - Formation
            </Link>
            <Link href={createSearchPagePathname('sector', 'School')} className={"link text-primary" + (sector === 'School' ? ' all active' : '')}>
                <i className="fi fi-rr-ruler-triangle" />
                Séjours scolaires
            </Link>
        </div>
    )
}